import { CmsObjectWithDefault } from '@components/Cms/types';

export type EmailLoginFormContainerCmsKey = 'emailFormatError' | 'passwordTooShortError' | 'userNameIsEmailError';
export const EmailLoginFormContainerCmsWithDefault: CmsObjectWithDefault<EmailLoginFormContainerCmsKey> = {
    emailFormatError: {
        cmsId: 67546,
        defaultTranslation: 'Email Address format is not valid.',
    },
    passwordTooShortError: {
        cmsId: 102136,
        defaultTranslation: 'Password is case sensitive and must be at least 8 characters long.',
    },
    userNameIsEmailError: {
        cmsId: 553961,
        defaultTranslation: 'Please enter your JTB Member ID, not your email address',
    },
};
